<div class="wrapper-lg">
    <app-breadcrumbs [items]="[
                     { url: '/student-course-equalizations', text: 'studentCourseEqualization_listTitle' },
                     {
                        url: '/student-course-equalizations/' + (isNew ? 'add' : model?.Id),
                        text: isNew ? 'studentCourseEqualization_newTitle' : isReady ? canEdit ? 'studentCourseEqualization_editTitle' : 'studentCourseEqualization_viewTitle' : '...'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{'studentCourseEqualization_title' | translate}}
            <app-student-course-equalization-status [value]="model.Status"></app-student-course-equalization-status>
        </h1>
        <aside *ngIf="canPickPerson && !personPickerOpened">
            <button type="button" class="btn btn-outline" (click)="togglePersonPicker()">
                <i class="fi fi-rs-user"></i>
                {{'studentCourseEqualization_btnPickStudent' | translate}}
            </button>
        </aside>
    </header>

    <app-person-picker *ngIf="personPickerOpened" (pick)="pickPerson($event)"></app-person-picker>

    <app-alert level="danger" *ngIf="isUnavailable && !personPickerOpened">
        {{'eServiceNotAvailable' | translate}}
    </app-alert>

    <form #form="ngForm" [class.was-validated]="formSubmitted" *ngIf="isReady && !isUnavailable && !personPickerOpened">
        <app-alert level="warning" *ngIf="model.ReturnComment">{{model.ReturnComment}}</app-alert>

        <div class="row" *ngIf="isNew && studentOptions.length > 1">
            <div class="col-sm-6 form-field">
                <label class="form-label">{{'studentCourseEqualization_lblChangeSpeciality' | translate}}</label>
                <app-select [(ngModel)]="selectedSpeciality"
                            [options]="studentOptions"
                            [displayFn]="specialityDisplayFn"
                            [required]="true"
                            (selectionChange)="setSpeciality(selectedSpeciality)"
                            name="selectedSpeciality">
                </app-select>
            </div>
        </div>

        <ng-container *ngIf="student">
            <div class="mb-2">
                <ngb-accordion #acc="ngbAccordion" activeIds="studentData">
                    <ngb-panel [title]="'studentCourseEqualization_studentData' | translate" id="studentData">
                        <ng-template ngbPanelContent>
                            <div class="row">
                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblStudent' | translate}}</label>
                                    <div>{{student.Name}} {{student.Surname}}</div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblEmail' | translate}}</label>
                                    <div>{{student.Email}}</div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblCertificateNumber' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.CertificateNumber; else noValue">
                                            {{student.CertificateNumber}}
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblMobile' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.Mobile; else noValue">
                                            {{student.Mobile}}
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblProgramme' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.SpecialityName; else noValue">
                                            {{student.SpecialityName}}
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblSupervisor' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.SupervisorFirstName; else noValue">
                                            {{student.SupervisorFirstName}} {{student.SupervisorLastName}}
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblStudyYear' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.StudyYear; else noValue">
                                            {{student.StudyYear}}
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="data-value col-md-6 col-lg-3">
                                    <label>{{'studentCourseEqualization_lblStatus' | translate}}</label>
                                    <div>
                                        <ng-container *ngIf="student.Status; else noValue">
                                            {{student.Status}}
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>
            </div>

            <app-alert *ngIf="model.ApprovalDecision" level="info">
                <label>{{'studentCourseEqualization_lblApprovalDecision' | translate}}</label>
                <div>{{model.ApprovalDecision}}</div>
                <div class="text-sub approval-comment" *ngIf="model.ApprovalComment">{{model.ApprovalComment}}</div>
            </app-alert>

            <ul ngbNav #nav="ngbNav" class="nav-tabs">
                <li [ngbNavItem]="'courses'">
                    <a ngbNavLink>
                        {{'studentCourseEqualization_tabCourses' | translate}}
                        <ng-container *ngIf="selectedCourseCount"> ({{selectedCourseCount}})</ng-container>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="mt-3" *ngIf="isCourseDataReady && isNew && !courseOptions.length">
                            <app-alert level="warning">{{'studentCourseEqualization_noCourseAvailable' | translate}}</app-alert>
                        </div>

                        <ng-container *ngIf="isCourseDataReady">
                            <section class="block-em course-block" [class.equalized]="isPowerUser && inner.ApprovalDecision" *ngFor="let inner of model.Courses">
                                <ng-container *ngIf="isPowerUser">
                                    <span *ngIf="inner.ApprovalDecision; else courseStatusInvalid"
                                          class="course-status"
                                          [class.text-bg-success]="inner.ApprovalDecisionCode == 'PassFull'"
                                          [class.text-bg-warning]="inner.ApprovalDecisionCode == 'PassPartial'"
                                          [class.text-bg-danger]="inner.ApprovalDecisionCode == 'Fail'">
                                        {{inner.ApprovalDecision}}
                                    </span>
                                    <ng-template #courseStatusInvalid>
                                        <app-alert level="warning">{{'studentCourseEqualization_fillInnerCourseInfo' | translate}}</app-alert>
                                    </ng-template>
                                </ng-container>

                                <div class="course-block-hero">
                                    <button type="button" class="course-block-toggle" (click)="util.toggle(inner)">
                                        <i class="fi fi-rs-angle-up" *ngIf="util.isExpanded(inner); else courseCollapsedIcon"></i>
                                        <ng-template #courseCollapsedIcon>
                                            <i class="fi fi-rs-angle-right"></i>
                                        </ng-template>
                                    </button>

                                    <div class="course-block-hero-content">
                                        <header class="block-header">
                                            <h5 class="course-block-title">
                                                <span>{{inner.Code}} {{inner.Name}}</span>
                                                <span class="text-sub">{{'studentCourseEqualization_courseToEqualize' | translate}}</span>
                                            </h5>

                                            <aside *ngIf="canEdit">
                                                <button type="button" (click)="editCourse(inner)" class="btn btn-outline-primary" *ngIf="isPowerUser">
                                                    <i class="fi fi-rs-exchange"></i>
                                                    {{'studentCourseEqualization_btnEqualize' | translate}}
                                                </button>

                                                <button *ngIf="inner.IsMy" type="button" (click)="removeCourse(inner)" class="btn btn-outline btn-icon" [ngbTooltip]="'remove' | translate">
                                                    <i class="fi fi-rs-trash"></i>
                                                </button>
                                            </aside>
                                        </header>

                                        <div class="course-block-stats">
                                            <div class="data-value">
                                                <label>{{'studentCourseEqualization_lblCreditedGrade' | translate}}</label>
                                                <div>
                                                    <ng-container *ngIf="inner.GradeValue || inner.IsEqualizedWithNoGrade; else noSupervisorValue">
                                                        {{inner.IsEqualizedWithNoGrade ? ('studentCourseEqualization_equalizedWithNoGrade' | translate) :  inner.GradeValue}}
                                                    </ng-container>
                                                </div>
                                            </div>

                                            <div class="data-value">
                                                <label>{{'studentCourseEqualization_lblCreditedEcts' | translate}}</label>
                                                <div>
                                                    {{getCreditedEcts(inner) | number:'1.0-2':'en-US'}}
                                                    <span class="mute">
                                                        {{'studentCourseEqualization_outOf' | translate}}
                                                    </span>
                                                    {{(inner.Ects) | number:'1.0-2':'en-US'}}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2" *ngIf="util.isExpanded(inner)">
                                    <app-table [rows]="inner.Courses" [columns]="outerColumns" [showTotal]="false" [style]="'plain'" sticky="right">
                                        <ng-template #rowTemplate let-row>
                                            <tr>
                                                <td>
                                                    <div class="text-top">{{row.Name}}</div>
                                                    <div class="text-mute" *ngIf="row.University">{{row.University}}</div>
                                                    <div class="text-mute" *ngIf="row.Programme">{{row.Programme}}</div>
                                                    <div class="hidden-md-up mt-1">{{'studentCourseEqualization_lblEcts' | translate}}: {{row.Ects | number:'1.0-2':'en-US'}}</div>
                                                    <div class="hidden-md-up">{{'studentCourseEqualization_lblGrade' | translate}}: {{row.GradeValue}}</div>
                                                    <div class="hidden-lg-up mt-1">
                                                        <div *ngFor="let a of row.Attachments" class="attachment-row d-flex" [title]="a.FileName">
                                                            <i class="fi fi-rs-document me-1"></i>
                                                            <a *ngIf="a.Id" href="#" (click)="$event.preventDefault(); downloadAttachment(a)">
                                                                {{a.FileName}}
                                                            </a>
                                                            <span *ngIf="!a.Id">
                                                                {{a.FileName}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="text-mute mt-1 d-flex" *ngIf="row.Notes">
                                                        <i class="fi fi-rs-comment me-1"></i>
                                                        <span>{{row.Notes}}</span>
                                                    </div>
                                                </td>
                                                <td class="hidden-sm-down">{{row.Ects | number:'1.0-2':'en-US'}}</td>
                                                <td class="hidden-sm-down">{{row.GradeValue}}</td>
                                                <td class="hidden-md-down">
                                                    <div *ngFor="let a of row.Attachments" class="attachment-row" [title]="a.FileName">
                                                        <span *ngIf="row.Attachments.length > 1">&bull;</span>
                                                        <a *ngIf="a.Id" href="#" (click)="$event.preventDefault(); downloadAttachment(a)">
                                                            {{util.compactFileName(a.FileName, 20)}}
                                                        </a>
                                                        <span *ngIf="!a.Id">
                                                            {{util.compactFileName(a.FileName, 20)}}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="table-actions">
                                                        <button (click)="viewCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="!canEdit"
                                                                [ngbTooltip]="'view' | translate">
                                                            <i class="fi fi-rs-angle-right"></i>
                                                        </button>

                                                        <button (click)="editCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="canEdit"
                                                                [ngbTooltip]="'edit' | translate">
                                                            <i class="fi fi-rs-pencil"></i>
                                                        </button>

                                                        <button (click)="removeCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="canEdit && !row.IsMy"
                                                                [ngbTooltip]="'remove' | translate">
                                                            <i class="fi fi-rs-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </app-table>

                                    <div class="mt-1 mb-2" *ngIf="canEdit">
                                        <button class="btn btn-tertiary" type="button" (click)="addCourse(inner)"
                                                [ngbTooltip]="'studentCourseEqualization_hintAddInnerCourse' | translate">
                                            <i class="fi fi-rs-plus"></i>
                                            {{'studentCourseEqualization_btnAddInnerCourse' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </section>

                            <div class="mt-4" *ngIf="canEdit">
                                <button class="btn btn-outline-primary" type="button" (click)="addCourse()"
                                        [ngbTooltip]="'studentCourseEqualization_hintAddOuterCourse' | translate">
                                    <i class="fi fi-rs-plus"></i>
                                    {{'studentCourseEqualization_btnAddOuterCourse' | translate}}
                                </button>
                            </div>
                        </ng-container>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>

            <div class="row mt-3" *ngIf="isPowerUser">
                <div class="form-field col-sm-6">
                    <label class="form-label">{{'studentCourseEqualization_lblEnrollSemester' | translate}}</label>
                    <app-select [(ngModel)]="model.EnrollSemester"
                                [options]="enrollSemesterOptions"
                                valueProperty="value"
                                displayProperty="text"
                                name="enrollYear">
                    </app-select>
                </div>
            </div>

            <div class="mt-3" *ngIf="canEdit && totalAttachments > attachmentLimit">
                <app-alert level="danger">
                    {{'studentCourseEqualization_maxFileCountExceeded' | translate | formatString:attachmentLimit}}
                </app-alert>
            </div>

            <div class="mt-3" *ngIf="canCreateProject && hasIncompleteCourse">
                <app-alert level="warning">
                    {{'studentCourseEqualization_fillInnerCourseInfo' | translate}}
                </app-alert>
            </div>
        </ng-container>

        <div class="form-actions">
            <span class="form-actions-group">
                <a class="btn btn-outline" href="{{dvsProtocolUrl}}" *ngIf="model.Status == 'Registered'">
                    <i class="fi fi-rs-document"></i>
                    {{'studentCourseEqualization_btnDvsDocument' | translate}}
                </a>

                <button class="btn btn-outline-primary" type="button" (click)="submit()" [disabled]="!student" *ngIf="canSubmit">
                    <i class="fi fi-rs-paper-plane"></i>
                    {{'studentCourseEqualization_btnSubmit' | translate}}
                </button>

                <button class="btn btn-secondary" type="button" (click)="returnForAddition()" *ngIf="canCreateProject">
                    <i class="fi fi-rs-arrow-left"></i>
                    {{'studentCourseEqualization_btnReturnForAddition' | translate}}
                </button>

                <button class="btn btn-outline-primary" type="button" (click)="createProject()" *ngIf="canCreateProject"
                        [disabled]="hasIncompleteCourse">
                    <i class="fi fi-rs-shield-check"></i>
                    {{'studentCourseEqualization_btnProject' | translate}}
                </button>
            </span>

            <span class="form-actions-group">
                <button class="btn btn-outline" type="button" [routerLink]="['/student-course-equalizations'] | localize">
                    {{(isNew ? 'studentCourseEqualization_btnCancel' : 'studentCourseEqualization_btnClose') | translate}}
                </button>

                <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!student" *ngIf="canEdit">
                    {{'studentCourseEqualization_btnSave' | translate}}
                </button>
            </span>
        </div>
    </form>
</div>

<ng-template #noValue>{{'studentCourseEqualization_undefined' | translate}}</ng-template>
<ng-template #noSupervisorValue>
    <ng-container *ngIf="!isPowerUser else noValue">
        {{'studentCourseEqualization_filledBySupervisor' | translate}}
    </ng-container>
</ng-template>
